import 'react-tabulator/lib/styles.css';
import "react-tabulator/lib/css/bootstrap/tabulator_bootstrap4.min.css";
import '../../resources/css/visual/VisualManagerList.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { filterOrgAction, filterGroupAction } from '../../actions/model/index';
import { ReactTabulator } from 'react-tabulator';
import { doActivePage } from '../../actions/menu/index';
// import { checkTableAuth } from '../../components/common/access-auth';
// import { dataFilter } from '../common/filter-data'
import { openModal, closeModal, popupModalConfirm, openModalAlert } from '../../actions/index';
import { dispathVisualMangerDetail, dispatchSaveVisualManager, doGetModalVisualData } from '../../actions/visual/index';
import { doDeleteVisualData } from '../../actions/visual/index';
import ListColumnBtn from '../common/ListColumnBtn';

// const listFooter = (
//   <span>
//       <span className='area-total-count'>
//         <label className='total-tip'>Total :</label>
//         <label className='total-value'>2</label>
//       </span>
//   </span>
// );

let componentProps = null;

// const addRow = () => {
//   if (componentProps) {
//     const { openModal, dispathVisualMangerDetail } = componentProps;
//     openModal("visualManager", 'add', null, () => dispathVisualMangerDetail(null));
//   }
// }


class VisualManagerList extends Component {

  tableId = 'VisualManagerList'
  // set this state for re-fresh sub component
  state = {
    test: null,
    refTable: null,
    isInitComplete: false,

    /**
     *  visibleColumnsConfig is array
     *  title is menu tile
     *  columns is all changed visible columns for table list to display
     */
    visibleColumnsConfig: {
      // title: 'Visual Manager Columns',
      columns: [
        // { name:'seq', title: "ID", field: "group" },
        // { name:'group', title: "Group Name", field: "groupName" },
        { name: 'id', title: "ID", field: "id" },
        { name: 'name', title: "Floor Plan Name", field: "name" },
        { name: 'description', title: "Description", field: "description" },
        { name: 'createdDate', title: "Created Date", field: "createdDate" },
        { name: 'createdBy', title: "Created By", field: "createdBy" },
        { name: 'lastUpdatedDate', title: "Last Updated Date", field: "lastUpdatedDate" },
        { name: 'lastUpdatedBy', title: "Last Updated By", field: "lastUpdatedBy" },
        { name: 'fileName', title: "File Name", field: "fileName" },
        // { name:'buttonGroup', title: "buttonGroup", field: "buttonGroup", visible: false }
      ]
    },

    sessionKey: 'SWS.VisualManagerListParams'
  }

  /**
   *  reactFormatter bug, GroupBtnsMenu -> need before than reactFormatter
   *  
   ***/
  columns = [
    // { title: "ID", field: "group" },
    // { title: "Group Name", field: "groupName" },
    { title: "ID", field: "id", visible: false },
    { title: "Floor Plan Name", field: "name" },
    { title: "Description", field: "description", visible: false },
    {
      title: "Created Date", field: "createdDate", visible: false, formatter: function (cell) {
        return cell.getValue().slice(0, 19);
      }
    },
    { title: "Created By", field: "createdBy", visible: false },
    {
      title: "Last Updated Date", field: "lastUpdatedDate", visible: false, formatter: function (cell) {
        return cell.getValue().slice(0, 19);
      }
    },
    { title: "Last Updated By", field: "lastUpdatedBy", visible: false },
    { title: "File Name", field: "fileName"}
    // { title: "", field: "buttonGroup", minWidth: 180, headerSort:false, formatter: reactFormatter(<GroupBtnsMenu />)}
  ];

  dataLoading = () => {
    // const { status, reloadPageNumber } = this.props;
    if (this.ref && !this.state.isInitComplete) {

      if (!componentProps) {
        componentProps = this.props;
      }

      this.setState({
        isInitComplete: true,
        refTable: this.ref.table
      });

    }
  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { menuMode/*, tabulatorDivHeight*/, selectGroup, saveConfirm } = this.props;
    const { refTable } = this.state;

    if (prevProps.menuMode !== menuMode) {
      // if menu chagne size(mode), need redraw table
      refTable.redraw(true);
    }

    if (refTable) {
      if (prevProps.selectGroup !== selectGroup && selectGroup) {
        // refTable.setFilter(dataFilter, {group:selectGroup})
        let lastPage = refTable.modules.page.getPageMax();
        if (refTable.modules.page.getPage() < lastPage) {
          refTable.modules.page.nextPage();
        }
      }
      // if (prevProps.selectSite !== selectSite && selectSite) {
      //   // refTable.setFilter(dataFilter, {group:selectGroup})
      //   orgFilter = selectSite;
      // }
    }

    if (prevProps.saveConfirm !== saveConfirm) {
      if (saveConfirm) {
        //reset show data and close modal
        const { closeModal, dispatchSaveVisualManager } = this.props;
        closeModal(null);
        if (refTable) {
          refTable.replaceData().then(function () {
            dispatchSaveVisualManager(null, false)
          });
        }
      }
    }

  }

  render() {
    // const paginationSize = this.refListCommonFooter ? this.refListCommonFooter.getPaginationSize() : this.props.pageSize;
    const { tabulatorDivHeight, authToken, dispathVisualMangerDetail, openModal, selectFloorPlanProject, doGetModalVisualData } = this.props;

    const options = {
      height: tabulatorDivHeight,
      ajaxProgressiveLoadDelay: 200,
      ajaxURL: window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER["visual"] + "/getvisualmanagerlist",
      paginationDataReceived: {
        last_page: "totalPages"
      },
      paginationSize: 10, //optional parameter to request a certain number of rows per page
      pagination: "local",
      paginationSizeSelector: true,
      ajaxConfig: {
        method: 'POST',
        mode: 'cors'
      },
      renderComplete: function () {

          const paginationElement = document.querySelector('.tabulator-paginator');

        console.log('bb renderComplete: paginator exists? ',paginationElement);

          if (paginationElement) {
            paginationElement.setAttribute('id', 'visual-manager-list-pagination');

            const pageSizeSelect = paginationElement.querySelector('select');
            if (pageSizeSelect) {
              pageSizeSelect.setAttribute('id', 'visual-manager-list-selections');
            }
          }

          const buttons = paginationElement.querySelectorAll('button');
          buttons.forEach(button => {
            switch (button.textContent.trim()) {
              case 'First':
                button.setAttribute('id', 'visual-manager-list-pagination-first-btn');
                break;
              case 'Prev':
                button.setAttribute('id', 'visual-manager-list-pagination-prev-btn');
                break;
              case 'Next':
                button.setAttribute('id', 'visual-manager-list-pagination-next-btn');
                break;
              case 'Last':
                button.setAttribute('id', 'visual-manager-list-pagination-last-btn');
                break;
              default:
                break;
            }
          })
      },
      ajaxContentType: {
        headers: {
          'Authorization': authToken,
          'Content-Type': 'application/json',
        },
        body: function () {
          return selectFloorPlanProject
        }
      },
      ajaxResponse: (url, params, response) => {
        return response.data; //return the response data to tabulator
      },
      ajaxError: () => {
        console.info(this.tableId + ' ajaxError');
      }
    };

    return (
      <div className='visual-manager-list'>
        <div className='area-add-btn'>
          <span id="floor-plan-manager-add" className='area-add-icon' onClick={() => openModal("visualMangerImportPDF", 'add-multi-floor', null, () => dispathVisualMangerDetail(null))}><span className="icon-btn-add-n"></span>Add Floor Plan </span>
        </div>
        <span className='area-setting-list-icon'>
          <ListColumnBtn tableId={this.tableId}
            refTable={this.state.refTable}
            refs={(ref) => { this.refTableToolBar = ref; }}
            visibleColumnsConfig={this.state.visibleColumnsConfig}>
          </ListColumnBtn>
        </span>
        

        <div className='custom-list-table-area'>
          <ReactTabulator
            ref={ref => (this.ref = ref)}
            columns={this.columns}
            data={[]}
            options={options}
            data-custom-attr="test-custom-attribute"
            className="custom-list-table"
            placeholder="No data found"
            dataLoading={this.dataLoading}
            rowClick={function (e, row) {
              openModal("visualManager", 'view', null, () => {
                dispathVisualMangerDetail(row._row.data);
                doGetModalVisualData(authToken, row._row.data.id);
              });
            }}
          // footerElement={listFooter}
          />
        </div>
      </div>
    )
  };
}

const mapStateToProps = (state) => {
  return {
    menuMode: state.menuReducers.displayMode,
    authToken: state.loginReducers.authToken,
    accountRole: state.loginReducers.accountRole,
    roleTableAuth: state.loginReducers.roleTableAuth,
    selectGroup: state.modelReducers.groupId,
    saveConfirm: state.visualReducers.saveConfirm,
    selectSite: state.siteReducers.selectSite,
    status: state.visualReducers.status,
    selectFloorPlanProject: state.visualReducers.selectFloorPlanProject

  }
}

export default withRouter(connect(
  mapStateToProps,
  {
    doActivePage,
    filterOrgAction,
    filterGroupAction,
    openModal,
    closeModal,
    popupModalConfirm,
    dispathVisualMangerDetail,
    dispatchSaveVisualManager,
    openModalAlert,
    doDeleteVisualData,
    doGetModalVisualData,
  }
)(VisualManagerList))
